import type { QuoteInfosTab } from './quoteDetail.model';

export type QuoteDetailPanelUiAction = SetPanelQuoteInfosActiveTab | ToggleQuoteInfosSection;

/* ############################# */
export function setPanelQuoteInfosActiveTab(tabId: string, activeTab: QuoteInfosTab) {
  return {
    type: 'SET_PANEL_QUOTE_INFOS_ACTIVE_TAB' as const,
    tabId,
    activeTab,
  };
}

type SetPanelQuoteInfosActiveTab = ReturnType<typeof setPanelQuoteInfosActiveTab>;

/* ############################# */
export function toggleQuoteInfosSection(tabId: string, section: string) {
  return {
    type: 'TOGGLE_QUOTE_INFOS_SECTION' as const,
    tabId,
    section,
  };
}
type ToggleQuoteInfosSection = ReturnType<typeof toggleQuoteInfosSection>;
